export default __webpack_public_path__ + "static/mosaic-dont-dark-e0d0b16a870f2cd4460d96e9f6740cff.png";